import { WidgetBase } from '@/core/widgets/model/news-widget';
import React from 'react';
import { useWidgetPermission } from '@/core/widgets/hooks/use-widget-permission';
import { UpgradePanel } from '@/shared/session/export';
import { useSessionIdentity } from '@/core/auth/export';

export default function HasWidgetPermissions({
  widget,
  children,
}: React.PropsWithChildren<{ widget: WidgetBase }>) {
  const { authorized, loadingPermission } = useWidgetPermission(widget);

  return (
    <>
      {!loadingPermission && (
        <>
          {!authorized && <UnauthorizedWidgetPanel widget={widget} />}
          {authorized && <>{children}</>}
        </>
      )}
    </>
  );
}

// Isolated so useSessionIdentity() (and its localStorage reads) only run for
// unauthorized widgets, not on every render of every widget on the page.
function UnauthorizedWidgetPanel({ widget }: { widget: WidgetBase }) {
  const identity = useSessionIdentity();

  return <UpgradePanel contentName={widget.defaultTitle} identity={identity} />;
}
